module.exports = __webpack_public_path__ + "spaceInvaders.png?32a4c0021d2ff659ae0f6b0a773f1c24";